//# sourceMappingURL=notif_preferences.mjs.map
/// <reference types="./notif_preferences.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $duration from "../../gleam_time/gleam/time/duration.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $uuid from "../../tiamat/crypto/uuid.mjs";
import * as $list_ from "../../tiamat/gleam/list_.mjs";
import { push } from "../../tiamat/gleam/list_.mjs";
import * as $duration_ from "../../tiamat/gleam/time/duration_.mjs";
import * as $function from "../../tiamat/tiamat/function.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class Preferences extends $CustomType {
  constructor(proposal_is_due, source_expire, proposal_finished_processing, user_mentioned_in_comment, questions_assigned, sources_assigned, digest, slack_weekly_digest, slack_digest_day, slack_digest_hour) {
    super();
    this.proposal_is_due = proposal_is_due;
    this.source_expire = source_expire;
    this.proposal_finished_processing = proposal_finished_processing;
    this.user_mentioned_in_comment = user_mentioned_in_comment;
    this.questions_assigned = questions_assigned;
    this.sources_assigned = sources_assigned;
    this.digest = digest;
    this.slack_weekly_digest = slack_weekly_digest;
    this.slack_digest_day = slack_digest_day;
    this.slack_digest_hour = slack_digest_hour;
  }
}
export const Preferences$Preferences = (proposal_is_due, source_expire, proposal_finished_processing, user_mentioned_in_comment, questions_assigned, sources_assigned, digest, slack_weekly_digest, slack_digest_day, slack_digest_hour) =>
  new Preferences(proposal_is_due,
  source_expire,
  proposal_finished_processing,
  user_mentioned_in_comment,
  questions_assigned,
  sources_assigned,
  digest,
  slack_weekly_digest,
  slack_digest_day,
  slack_digest_hour);
export const Preferences$isPreferences = (value) =>
  value instanceof Preferences;
export const Preferences$Preferences$proposal_is_due = (value) =>
  value.proposal_is_due;
export const Preferences$Preferences$0 = (value) => value.proposal_is_due;
export const Preferences$Preferences$source_expire = (value) =>
  value.source_expire;
export const Preferences$Preferences$1 = (value) => value.source_expire;
export const Preferences$Preferences$proposal_finished_processing = (value) =>
  value.proposal_finished_processing;
export const Preferences$Preferences$2 = (value) =>
  value.proposal_finished_processing;
export const Preferences$Preferences$user_mentioned_in_comment = (value) =>
  value.user_mentioned_in_comment;
export const Preferences$Preferences$3 = (value) =>
  value.user_mentioned_in_comment;
export const Preferences$Preferences$questions_assigned = (value) =>
  value.questions_assigned;
export const Preferences$Preferences$4 = (value) => value.questions_assigned;
export const Preferences$Preferences$sources_assigned = (value) =>
  value.sources_assigned;
export const Preferences$Preferences$5 = (value) => value.sources_assigned;
export const Preferences$Preferences$digest = (value) => value.digest;
export const Preferences$Preferences$6 = (value) => value.digest;
export const Preferences$Preferences$slack_weekly_digest = (value) =>
  value.slack_weekly_digest;
export const Preferences$Preferences$7 = (value) => value.slack_weekly_digest;
export const Preferences$Preferences$slack_digest_day = (value) =>
  value.slack_digest_day;
export const Preferences$Preferences$8 = (value) => value.slack_digest_day;
export const Preferences$Preferences$slack_digest_hour = (value) =>
  value.slack_digest_hour;
export const Preferences$Preferences$9 = (value) => value.slack_digest_hour;

export class Reminder extends $CustomType {
  constructor(id, amount, time_unit, before) {
    super();
    this.id = id;
    this.amount = amount;
    this.time_unit = time_unit;
    this.before = before;
  }
}
export const Reminder$Reminder = (id, amount, time_unit, before) =>
  new Reminder(id, amount, time_unit, before);
export const Reminder$isReminder = (value) => value instanceof Reminder;
export const Reminder$Reminder$id = (value) => value.id;
export const Reminder$Reminder$0 = (value) => value.id;
export const Reminder$Reminder$amount = (value) => value.amount;
export const Reminder$Reminder$1 = (value) => value.amount;
export const Reminder$Reminder$time_unit = (value) => value.time_unit;
export const Reminder$Reminder$2 = (value) => value.time_unit;
export const Reminder$Reminder$before = (value) => value.before;
export const Reminder$Reminder$3 = (value) => value.before;

export class ProposalIsDue extends $CustomType {}
export const Kind$ProposalIsDue = () => new ProposalIsDue();
export const Kind$isProposalIsDue = (value) => value instanceof ProposalIsDue;

export class SourceExpire extends $CustomType {}
export const Kind$SourceExpire = () => new SourceExpire();
export const Kind$isSourceExpire = (value) => value instanceof SourceExpire;

export class ProposalFinishedProcessing extends $CustomType {}
export const Kind$ProposalFinishedProcessing = () =>
  new ProposalFinishedProcessing();
export const Kind$isProposalFinishedProcessing = (value) =>
  value instanceof ProposalFinishedProcessing;

export class UserMentionedInComment extends $CustomType {}
export const Kind$UserMentionedInComment = () => new UserMentionedInComment();
export const Kind$isUserMentionedInComment = (value) =>
  value instanceof UserMentionedInComment;

export class QuestionsAssigned extends $CustomType {}
export const Kind$QuestionsAssigned = () => new QuestionsAssigned();
export const Kind$isQuestionsAssigned = (value) =>
  value instanceof QuestionsAssigned;

export class SourcesAssigned extends $CustomType {}
export const Kind$SourcesAssigned = () => new SourcesAssigned();
export const Kind$isSourcesAssigned = (value) =>
  value instanceof SourcesAssigned;

export class Digest extends $CustomType {}
export const Kind$Digest = () => new Digest();
export const Kind$isDigest = (value) => value instanceof Digest;

export class Hour extends $CustomType {}
export const TimeUnit$Hour = () => new Hour();
export const TimeUnit$isHour = (value) => value instanceof Hour;

export class Day extends $CustomType {}
export const TimeUnit$Day = () => new Day();
export const TimeUnit$isDay = (value) => value instanceof Day;

export class Week extends $CustomType {}
export const TimeUnit$Week = () => new Week();
export const TimeUnit$isWeek = (value) => value instanceof Week;

export class Month extends $CustomType {}
export const TimeUnit$Month = () => new Month();
export const TimeUnit$isMonth = (value) => value instanceof Month;

export class Year extends $CustomType {}
export const TimeUnit$Year = () => new Year();
export const TimeUnit$isYear = (value) => value instanceof Year;

export class Never extends $CustomType {}
export const Frequency$Never = () => new Never();
export const Frequency$isNever = (value) => value instanceof Never;

export class Daily extends $CustomType {}
export const Frequency$Daily = () => new Daily();
export const Frequency$isDaily = (value) => value instanceof Daily;

export class Weekly extends $CustomType {}
export const Frequency$Weekly = () => new Weekly();
export const Frequency$isWeekly = (value) => value instanceof Weekly;

export class Monthly extends $CustomType {}
export const Frequency$Monthly = () => new Monthly();
export const Frequency$isMonthly = (value) => value instanceof Monthly;

export function empty() {
  return new Preferences(
    toList([]),
    toList([]),
    false,
    false,
    false,
    false,
    new Never(),
    false,
    0,
    9,
  );
}

export function default$() {
  return new Preferences(
    toList([
      new Reminder($uuid.new$(), 1, new Week(), true),
      new Reminder($uuid.new$(), 1, new Day(), true),
    ]),
    toList([new Reminder($uuid.new$(), 1, new Day(), true)]),
    true,
    true,
    true,
    true,
    new Weekly(),
    true,
    0,
    9,
  );
}

export function default_reminder() {
  return new Reminder($uuid.new$(), 1, new Day(), true);
}

function frequency_decoder() {
  return $decode.then$(
    $decode.string,
    (variant) => {
      if (variant === "never") {
        return $decode.success(new Never());
      } else if (variant === "daily") {
        return $decode.success(new Daily());
      } else if (variant === "weekly") {
        return $decode.success(new Weekly());
      } else if (variant === "monthly") {
        return $decode.success(new Monthly());
      } else {
        return $decode.failure(new Never(), "Frequency");
      }
    },
  );
}

function time_unit_decoder() {
  return $decode.then$(
    $decode.string,
    (variant) => {
      if (variant === "hour") {
        return $decode.success(new Hour());
      } else if (variant === "day") {
        return $decode.success(new Day());
      } else if (variant === "week") {
        return $decode.success(new Week());
      } else if (variant === "month") {
        return $decode.success(new Month());
      } else if (variant === "year") {
        return $decode.success(new Year());
      } else {
        return $decode.failure(new Week(), "TimeUnit");
      }
    },
  );
}

function reminder_decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.field(
        "amount",
        $decode.int,
        (amount) => {
          return $decode.field(
            "time_unit",
            time_unit_decoder(),
            (time_unit) => {
              return $decode.field(
                "before",
                $decode.bool,
                (before) => {
                  return $decode.success(
                    new Reminder(id, amount, time_unit, before),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function decoder() {
  return $decode.field(
    "proposal_is_due",
    $decode.list(reminder_decoder()),
    (proposal_is_due) => {
      return $decode.field(
        "source_expire",
        $decode.list(reminder_decoder()),
        (source_expire) => {
          return $decode.field(
            "proposal_finished_processing",
            $decode.bool,
            (proposal_finished_processing) => {
              return $decode.field(
                "user_mentioned_in_comment",
                $decode.bool,
                (user_mentioned_in_comment) => {
                  return $decode.field(
                    "questions_assigned",
                    $decode.bool,
                    (questions_assigned) => {
                      return $decode.field(
                        "sources_assigned",
                        $decode.bool,
                        (sources_assigned) => {
                          return $decode.field(
                            "digest",
                            frequency_decoder(),
                            (digest) => {
                              return $decode.optional_field(
                                "slack_weekly_digest",
                                true,
                                $decode.bool,
                                (slack_weekly_digest) => {
                                  return $decode.optional_field(
                                    "slack_digest_day",
                                    0,
                                    $decode.int,
                                    (slack_digest_day) => {
                                      return $decode.optional_field(
                                        "slack_digest_hour",
                                        9,
                                        $decode.int,
                                        (slack_digest_hour) => {
                                          return $decode.success(
                                            new Preferences(
                                              proposal_is_due,
                                              source_expire,
                                              proposal_finished_processing,
                                              user_mentioned_in_comment,
                                              questions_assigned,
                                              sources_assigned,
                                              digest,
                                              slack_weekly_digest,
                                              slack_digest_day,
                                              slack_digest_hour,
                                            ),
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

/**
 * Preferences as *stored*, a weaker contract than preferences as *sent by a
 * client*: a row can predate a field, or exist only because `upsert_function`
 * created it and let the column take its `{}` default. Such a value means
 * "this user never expressed preferences", so it reads as `default()` instead
 * of failing — and, in a batched read, instead of failing every other row
 * alongside it.
 *
 * Never use this on a request body: `PATCH /user/preferences` must keep
 * rejecting a malformed payload, so that path stays on `decoder`.
 */
export function stored_decoder() {
  return $decode.one_of(decoder(), toList([$decode.success(default$())]));
}

function frequency_to_json(frequency) {
  if (frequency instanceof Never) {
    return $json.string("never");
  } else if (frequency instanceof Daily) {
    return $json.string("daily");
  } else if (frequency instanceof Weekly) {
    return $json.string("weekly");
  } else {
    return $json.string("monthly");
  }
}

function time_unit_to_json(time_unit) {
  if (time_unit instanceof Hour) {
    return $json.string("hour");
  } else if (time_unit instanceof Day) {
    return $json.string("day");
  } else if (time_unit instanceof Week) {
    return $json.string("week");
  } else if (time_unit instanceof Month) {
    return $json.string("month");
  } else {
    return $json.string("year");
  }
}

function reminder_to_json(reminder) {
  let id = reminder.id;
  let amount = reminder.amount;
  let time_unit = reminder.time_unit;
  let before = reminder.before;
  return $json.object(
    toList([
      ["id", $json.string(id)],
      ["amount", $json.int(amount)],
      ["time_unit", time_unit_to_json(time_unit)],
      ["before", $json.bool(before)],
    ]),
  );
}

export function to_json(preferences) {
  let proposal_is_due = preferences.proposal_is_due;
  let source_expire = preferences.source_expire;
  let proposal_finished_processing = preferences.proposal_finished_processing;
  let user_mentioned_in_comment = preferences.user_mentioned_in_comment;
  let questions_assigned = preferences.questions_assigned;
  let sources_assigned = preferences.sources_assigned;
  let digest = preferences.digest;
  let slack_weekly_digest = preferences.slack_weekly_digest;
  let slack_digest_day = preferences.slack_digest_day;
  let slack_digest_hour = preferences.slack_digest_hour;
  return $json.object(
    toList([
      ["proposal_is_due", $json.array(proposal_is_due, reminder_to_json)],
      ["source_expire", $json.array(source_expire, reminder_to_json)],
      ["proposal_finished_processing", $json.bool(proposal_finished_processing)],
      ["user_mentioned_in_comment", $json.bool(user_mentioned_in_comment)],
      ["questions_assigned", $json.bool(questions_assigned)],
      ["sources_assigned", $json.bool(sources_assigned)],
      ["digest", frequency_to_json(digest)],
      ["slack_weekly_digest", $json.bool(slack_weekly_digest)],
      ["slack_digest_day", $json.int(slack_digest_day)],
      ["slack_digest_hour", $json.int(slack_digest_hour)],
    ]),
  );
}

export function kind_name(kind) {
  if (kind instanceof ProposalIsDue) {
    return "Proposal Due Date";
  } else if (kind instanceof SourceExpire) {
    return "Source Expiration Date";
  } else if (kind instanceof ProposalFinishedProcessing) {
    return "Proposal finished processing";
  } else if (kind instanceof UserMentionedInComment) {
    return "Mentioned in a comment";
  } else if (kind instanceof QuestionsAssigned) {
    return "Question assigned in a proposal";
  } else if (kind instanceof SourcesAssigned) {
    return "Data sources assigned";
  } else {
    return "Digest frequency";
  }
}

export function kind_description(kind) {
  if (kind instanceof ProposalIsDue) {
    return "Receive a notification when a proposal is due soon.";
  } else if (kind instanceof SourceExpire) {
    return "Receive a notification when a source in the Content Library is about to expire.";
  } else if (kind instanceof ProposalFinishedProcessing) {
    return "Receive a notification when the AI has finished processing a proposal.";
  } else if (kind instanceof UserMentionedInComment) {
    return "Receive a notification when someone mentions you in a proposal comment.";
  } else if (kind instanceof QuestionsAssigned) {
    return "Receive a notification when you are assigned questions in a proposal.";
  } else if (kind instanceof SourcesAssigned) {
    return "Receive a notification when you are assigned data sources in the content library.";
  } else {
    return "Receive a summary of all activity related to you in the app.";
  }
}

export function update_toggle(preferences, kind, toggle) {
  if (kind instanceof ProposalFinishedProcessing) {
    return new Preferences(
      preferences.proposal_is_due,
      preferences.source_expire,
      toggle,
      preferences.user_mentioned_in_comment,
      preferences.questions_assigned,
      preferences.sources_assigned,
      preferences.digest,
      preferences.slack_weekly_digest,
      preferences.slack_digest_day,
      preferences.slack_digest_hour,
    );
  } else if (kind instanceof UserMentionedInComment) {
    return new Preferences(
      preferences.proposal_is_due,
      preferences.source_expire,
      preferences.proposal_finished_processing,
      toggle,
      preferences.questions_assigned,
      preferences.sources_assigned,
      preferences.digest,
      preferences.slack_weekly_digest,
      preferences.slack_digest_day,
      preferences.slack_digest_hour,
    );
  } else if (kind instanceof QuestionsAssigned) {
    return new Preferences(
      preferences.proposal_is_due,
      preferences.source_expire,
      preferences.proposal_finished_processing,
      preferences.user_mentioned_in_comment,
      toggle,
      preferences.sources_assigned,
      preferences.digest,
      preferences.slack_weekly_digest,
      preferences.slack_digest_day,
      preferences.slack_digest_hour,
    );
  } else if (kind instanceof SourcesAssigned) {
    return new Preferences(
      preferences.proposal_is_due,
      preferences.source_expire,
      preferences.proposal_finished_processing,
      preferences.user_mentioned_in_comment,
      preferences.questions_assigned,
      toggle,
      preferences.digest,
      preferences.slack_weekly_digest,
      preferences.slack_digest_day,
      preferences.slack_digest_hour,
    );
  } else {
    return preferences;
  }
}

export function update_frequency(preferences, kind, frequency) {
  if (kind instanceof Digest) {
    return new Preferences(
      preferences.proposal_is_due,
      preferences.source_expire,
      preferences.proposal_finished_processing,
      preferences.user_mentioned_in_comment,
      preferences.questions_assigned,
      preferences.sources_assigned,
      frequency,
      preferences.slack_weekly_digest,
      preferences.slack_digest_day,
      preferences.slack_digest_hour,
    );
  } else {
    return preferences;
  }
}

function replace_reminder(reminders, new_reminder) {
  let _pipe = reminders;
  return $list.map(
    _pipe,
    (reminder) => {
      let r = reminder;
      if (r.id === new_reminder.id) {
        return new_reminder;
      } else {
        return reminder;
      }
    },
  );
}

export function update_reminder(preferences, kind, reminder) {
  if (kind instanceof ProposalIsDue) {
    return new Preferences(
      replace_reminder(preferences.proposal_is_due, reminder),
      preferences.source_expire,
      preferences.proposal_finished_processing,
      preferences.user_mentioned_in_comment,
      preferences.questions_assigned,
      preferences.sources_assigned,
      preferences.digest,
      preferences.slack_weekly_digest,
      preferences.slack_digest_day,
      preferences.slack_digest_hour,
    );
  } else if (kind instanceof SourceExpire) {
    return new Preferences(
      preferences.proposal_is_due,
      replace_reminder(preferences.source_expire, reminder),
      preferences.proposal_finished_processing,
      preferences.user_mentioned_in_comment,
      preferences.questions_assigned,
      preferences.sources_assigned,
      preferences.digest,
      preferences.slack_weekly_digest,
      preferences.slack_digest_day,
      preferences.slack_digest_hour,
    );
  } else {
    return preferences;
  }
}

export function add_reminder(preferences, kind, reminder) {
  if (kind instanceof ProposalIsDue) {
    return new Preferences(
      push(preferences.proposal_is_due, reminder),
      preferences.source_expire,
      preferences.proposal_finished_processing,
      preferences.user_mentioned_in_comment,
      preferences.questions_assigned,
      preferences.sources_assigned,
      preferences.digest,
      preferences.slack_weekly_digest,
      preferences.slack_digest_day,
      preferences.slack_digest_hour,
    );
  } else if (kind instanceof SourceExpire) {
    return new Preferences(
      preferences.proposal_is_due,
      push(preferences.source_expire, reminder),
      preferences.proposal_finished_processing,
      preferences.user_mentioned_in_comment,
      preferences.questions_assigned,
      preferences.sources_assigned,
      preferences.digest,
      preferences.slack_weekly_digest,
      preferences.slack_digest_day,
      preferences.slack_digest_hour,
    );
  } else {
    return preferences;
  }
}

export function remove_reminder(preferences, kind, reminder_id) {
  if (kind instanceof ProposalIsDue) {
    return new Preferences(
      $list.filter(
        preferences.proposal_is_due,
        (reminder) => { return reminder.id !== reminder_id; },
      ),
      preferences.source_expire,
      preferences.proposal_finished_processing,
      preferences.user_mentioned_in_comment,
      preferences.questions_assigned,
      preferences.sources_assigned,
      preferences.digest,
      preferences.slack_weekly_digest,
      preferences.slack_digest_day,
      preferences.slack_digest_hour,
    );
  } else if (kind instanceof SourceExpire) {
    return new Preferences(
      preferences.proposal_is_due,
      $list.filter(
        preferences.source_expire,
        (reminder) => { return reminder.id !== reminder_id; },
      ),
      preferences.proposal_finished_processing,
      preferences.user_mentioned_in_comment,
      preferences.questions_assigned,
      preferences.sources_assigned,
      preferences.digest,
      preferences.slack_weekly_digest,
      preferences.slack_digest_day,
      preferences.slack_digest_hour,
    );
  } else {
    return preferences;
  }
}

export function timestamp_add_reminder(date, reminder) {
  let _block;
  let $ = reminder.time_unit;
  if ($ instanceof Hour) {
    _block = $duration.hours;
  } else if ($ instanceof Day) {
    _block = $duration_.days;
  } else if ($ instanceof Week) {
    _block = $duration_.weeks;
  } else if ($ instanceof Month) {
    _block = $duration_.months;
  } else {
    _block = $duration_.years;
  }
  let duration_function = _block;
  let _block$1;
  let $1 = reminder.before;
  if ($1) {
    _block$1 = $function.identity;
  } else {
    _block$1 = (x) => { return $int.subtract(0, x); };
  }
  let add_or_substract = _block$1;
  let _block$2;
  let _pipe = reminder.amount;
  let _pipe$1 = add_or_substract(_pipe);
  _block$2 = duration_function(_pipe$1);
  let duration = _block$2;
  return $timestamp.add(date, duration);
}

export function timestamp_remove_reminder(deadline, reminder) {
  let _block;
  let $ = reminder.time_unit;
  if ($ instanceof Hour) {
    _block = $duration.hours;
  } else if ($ instanceof Day) {
    _block = $duration_.days;
  } else if ($ instanceof Week) {
    _block = $duration_.weeks;
  } else if ($ instanceof Month) {
    _block = $duration_.months;
  } else {
    _block = $duration_.years;
  }
  let duration_function = _block;
  let _block$1;
  let $1 = reminder.before;
  if ($1) {
    _block$1 = (x) => { return $int.subtract(0, x); };
  } else {
    _block$1 = $function.identity;
  }
  let add_or_substract = _block$1;
  let _block$2;
  let _pipe = reminder.amount;
  let _pipe$1 = add_or_substract(_pipe);
  _block$2 = duration_function(_pipe$1);
  let duration = _block$2;
  return $timestamp.add(deadline, duration);
}

function reminder_to_duration(reminder) {
  let _block;
  let $ = reminder.time_unit;
  if ($ instanceof Hour) {
    _block = $duration.hours;
  } else if ($ instanceof Day) {
    _block = $duration_.days;
  } else if ($ instanceof Week) {
    _block = $duration_.weeks;
  } else if ($ instanceof Month) {
    _block = $duration_.months;
  } else {
    _block = $duration_.years;
  }
  let duration_function = _block;
  let _block$1;
  let $1 = reminder.before;
  if ($1) {
    _block$1 = (x) => { return $int.subtract(0, x); };
  } else {
    _block$1 = $function.identity;
  }
  let add_or_substract = _block$1;
  let _pipe = reminder.amount;
  let _pipe$1 = add_or_substract(_pipe);
  return duration_function(_pipe$1);
}

export function compare_reminders(r1, r2) {
  let d1 = reminder_to_duration(r1);
  let d2 = reminder_to_duration(r2);
  let t1 = $timestamp.add($timestamp.from_unix_seconds(0), d1);
  let t2 = $timestamp.add($timestamp.from_unix_seconds(0), d2);
  return $timestamp.compare(t1, t2);
}
